module.exports = __webpack_public_path__ + "img/kaufaufrechnung.94460c0.png";